import MicroModal from 'micromodal';
export const closeModal = () => {
    MicroModal.close('micromodal-root');
};
export const openModal = (content, onShow) => {
    const modalRoot = document.querySelector('#micromodal-root');
    if (modalRoot === null) {
        console.error('#micromodal-root was not found, does it exist?');
        return;
    }
    const container = modalRoot.querySelector('.container');
    if (container === null) {
        console.error('#micromodal-root .container was not found, does it exist?');
        return;
    }
    container.innerHTML = content;
    MicroModal.show('micromodal-root', {
        disableScroll: true,
        onShow: (modal) => {
            if (onShow && modal instanceof HTMLElement) {
                onShow(modal);
            }
        },
        onClose: (modal, activeElement, event) => {
            // Zapobiegnięcie kliknięciu w element pod overlay w przypadku urządzeń mobilnych
            if (typeof event !== 'undefined' && event !== null) {
                event.preventDefault();
                event.stopPropagation();
            }
        },
    });
};
